/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "Cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('Cart:refresh', {
 *   bubbles: true
 * }));
 */

theme.event_tracker = {
  variables: {},
  init: async () => {
    // mixpanel.init("8c3f2f1107470b3919a4a2c553fb9696", {
    //   track_pageview:
    //     window.location.href === "https://simpleorganic.com.br/" ? false : true,
    //   persistence: "localStorage",
    // });
    theme.event_tracker.variables.customer_state = window._simplecore.customer
      ? "logged_in"
      : "not_logged_in";

    // mixpanel.register({
    //   page_type: window.getPageType(),
    //   customer_state: theme.event_tracker.variables.customer_state,
    // });

    if (window._simplecore.customer && window._simplecore.customer.email) {
      let customer_identity = window._simplecore.customer.email;
      // mixpanel.identify(customer_identity);
    }
  },
  event: (event_name, event_props = {}, platforms = ["mixpanel", "gtag"]) => {
    if (!event_name) {
      return;
    }
    var event_props = {
      ...event_props,
    };
    if (platforms.includes("mixpanel")) {
      // mixpanel.track(event_name, event_props);
    }
    if (platforms.includes("gtag")) {
      gtag("event", event_name, {
        ...event_props,
        value: 1,
      });
    }
  },
};

theme.events = {
  homepage: {
    variables: {},
    init: async () => {
      await theme.events.homepage.set_events();
    },
    setEventHandlers: async (
      selector,
      sectionType,
      eventTitle,
      bannerSectionType,
      bannerSectionTitle
    ) => {
      const banners = document.querySelectorAll(selector);
      for (let i = 0; i < banners.length; i++) {
        const banner = banners[i];
        let $banner_position = i;
        let $banner_id = banner.getAttribute("data-banner-id");

        let banner_visible = false;

        let trackClicks = () => {
          banner.addEventListener("click", () => {
            theme.event_tracker.event(
              `${eventTitle} Click`,
              {
                section_type: bannerSectionType,
                section_title: bannerSectionTitle,
                banner_position: $banner_position,
                banner_id: $banner_id,
              },
              ["gtag"]
            );
          });
        };

        let trackImpressions = () => {
          let banner_in_viewport = window.isInViewport(banner);
          if (banner_in_viewport) {
            if (banner_visible === banner_in_viewport) return;
            theme.event_tracker.event(
              `${eventTitle} Impression`,
              {
                section_type: bannerSectionType,
                section_title: bannerSectionTitle,
                banner_position: $banner_position,
                banner_id: $banner_id,
              },
              ["gtag"]
            );
            banner_visible = true;
          } else {
            banner_visible = false;
          }
        };

        trackImpressions();
        trackClicks();

        document.addEventListener("scroll", trackImpressions, {
          passive: true,
        });

        document.addEventListener(`so.${sectionType}:impression`, (event) => {
          let $details = event.detail;
          if ($details.slideshow_name === `homepage-${bannerSectionType}`) {
            $banner_position = $details.banner_position;
            $banner_id = $details.slide_id;
            trackImpressions();
          }
        });

        document.addEventListener(`so.${sectionType}:click`, (event) => {
          let $details = event.detail;
          if ($details.slideshow_name === `homepage-${bannerSectionType}`) {
            $banner_position = $details.banner_position;
            $banner_id = $details.slide_id;
            trackClicks();
          }
        });
      }
    },
    set_events: async () => {
      const sectionTypes = [
        {
          selector:
            '.template-index [data-section-type="slideshow"] .Carousel__Cell',
          sectionType: "slideshow",
          eventTitle: "Homepage Banner",
          bannerSectionType: "main_banner",
          bannerSectionTitle: "main_banner",
        },
        {
          selector:
            '.template-index [data-section-type="collection-list"] .Carousel__Cell',
          sectionType: "collection_list_item",
          eventTitle: "Homepage Banner",
          bannerSectionType: "secondary_banner",
          bannerSectionTitle: "secondary_banner",
        },
        {
          selector:
            '[data-section-type="buttons-links-list"] .ButtonLinksList__Item',
          sectionType: "collection_list_item",
          eventTitle: "Homepage Button Link",
          bannerSectionType: "button_link_list",
          bannerSectionTitle: "buy_by_need",
        },
        // Adicione mais tipos de eventos conforme necessário
      ];

      for (const {
        selector,
        sectionType,
        eventTitle,
        bannerSectionType,
        bannerSectionTitle,
      } of sectionTypes) {
        await theme.events.homepage.setEventHandlers(
          selector,
          sectionType,
          eventTitle,
          bannerSectionType,
          bannerSectionTitle
        );
      }

      // RD FORM BUTTON EVENT
      setTimeout(() => {
        let rdButtons = document.querySelectorAll(
          ".bricks-form__submit .rd-button"
        );
        let registerButtons = document.querySelectorAll(
          '[href="/account/register"]'
        );
        for (const button of rdButtons) {
          button.addEventListener("click", () => {
            gtag("event", "conversion", {
              send_to: "AW-594372835/D1PLCMXttJsZEOPRtZsC",
            });
          });
        }
        for (const registerButton of registerButtons) {
          registerButton.addEventListener("click", () => {
            gtag("event", "conversion", {
              send_to: "AW-594372835/D1PLCMXttJsZEOPRtZsC",
            });
          });
        }
      }, 5000);
    },
  },
  product_item: {
    variables: {},
    init: async () => {
      await theme.events.product_item.set_events();
    },
    setEventHandlers: async (index = 0) => {
      let trackAddToCart = () => {
        let addToCartFormList = document.querySelectorAll(
          '[action="/cart/add"]'
        );
        for (const addToCartForm of addToCartFormList) {
          addToCartForm.addEventListener("submit", () => {
            const $product_titles =
              addToCartForm.querySelector('[name="product_title"]')?.value ||
              addToCartForm
                .querySelector("[data-product-title]")
                .getAttribute("data-product-title");
            let $product_properties = addToCartForm.querySelector(
              '[name="properties"]'
            )?.value;

            if ($product_properties) {
              $product_properties = JSON.parse($product_properties);
            }

            if ($product_titles) {
              for (const product_title of $product_titles.split(";")) {
                theme.event_tracker.event("Add to Cart", {
                  product: `${product_title}`,
                  ...$product_properties,
                });
              }
            }
          });
        }
      };
      let trackImpressions = () => {
        let productItemList = document.querySelectorAll('[action="/cart/add"]');
        for (const productItem of productItemList) {
          let $product_titles = productItem.querySelector(
            '[name="product_title"]'
          )?.value;
          if (!$product_titles) {
            if (productItem.querySelector("[data-product-title]")) {
              $product_titles = productItem
                .querySelector("[data-product-title]")
                .getAttribute("data-product-title");
            }
          }
          let $product_properties = productItem.querySelector(
            '[name="properties"]'
          )?.value;

          if ($product_properties) {
            $product_properties = JSON.parse($product_properties);
          }

          if ($product_titles) {
            for (const product_title of $product_titles.split(";")) {
              // theme.event_tracker.event("Product Impression", {
              //   product: `${product_title}`,
              //   ...$product_properties,
              // });
            }
          }
        }
      };
      trackImpressions();
      trackAddToCart();
    },
    set_events: async () => {
      theme.events.product_item.setEventHandlers();
    },
  },
  product_page: {
    variables: {},
    init: async () => {
      // await theme.events.product_page.set_events();
    },
    set_product_details_events: async (index = 0) => {
      const $product_details = JSON.parse(
        document.querySelector("[data-product-json]").innerHTML
      );

      let addToCartBtn = document.querySelector(
        '[action="/cart/add"] [type="submit"]'
      );
      if ($product_details) {
        // theme.event_tracker.event("Product Impression", {
        //   section_type: "product_page_details",
        //   product: `${$product_details.product.title}`,
        // });
        addToCartBtn.addEventListener("click", () => {
          theme.event_tracker.event("Add to Cart", {
            section_type: "product_page_details",
            product: `${$product_details.product.title}`,
          });
        });
      }
    },
    set_events: async () => {
      theme.events.product_page.set_product_details_events();
    },
  },
  minicart: {
    variables: {},
    init: async () => {
      await theme.events.minicart.set_events();
    },
    set_product_details_events: async (index = 0) => {
      setInterval(() => {
        if (!window.EvolveCore) {
          return;
        }
        let $cart_details = EvolveCore.Cart._store;
        let addToCartBtn = document.querySelector(
          ".Minicart__Wrapper .btn-checkout"
        );
        if (addToCartBtn) {
          let addToCartBtnClasses = [...addToCartBtn.classList];
          if (
            !addToCartBtnClasses.includes("btn-checkout--tracked") &&
            $cart_details
          ) {
            addToCartBtn.addEventListener("click", () => {
              theme.event_tracker.event("Go To Checkout", {
                section_type: "minicart",
              });
            });
            addToCartBtn.classList.add("btn-checkout--tracked");
          }
        }
      }, 1000);
    },
    set_events: async () => {
      theme.events.minicart.set_product_details_events();
    },
  },
  popup: {
    variables: {},
    init: async () => {
      await theme.events.popup.set_events();
    },
    set_popup_events: async (index = 0) => {
      document.addEventListener(`so.popup:impression`, (event) => {
        theme.event_tracker.event("Popup Impression", {
          section_type: "popup",
        });
      });
      document.addEventListener(`so.popup:conversion`, (event) => {
        theme.event_tracker.event("Popup Conversion", {
          section_type: "popup",
        });
      });
    },
    set_events: async () => {
      theme.events.popup.set_popup_events();
    },
  },
  search: {
    variables: {},
    init: async () => {
      await theme.events.search.set_events();
    },
    set_search_events: async (index = 0) => {
      document.addEventListener(`so.search:autofill_term:click`, (event) => {
        theme.event_tracker.event("Search Term Click", {
          section_type: "search",
          term_category: "top_search_terms",
          term_type: event.detail.term,
        });
      });
      document.addEventListener(`so.search:top_category:click`, (event) => {
        theme.event_tracker.event("Search Term Click", {
          section_type: "search",
          term_category: "top_categories",
          term_type: event.detail.term,
        });
      });
      document.addEventListener(`search:highlight_item:click`, (event) => {
        theme.event_tracker.event("Search Term Click", {
          section_type: "search",
          term_category: "search_highlight",
          term_type: event.detail.term,
        });
      });
    },
    set_events: async () => {
      theme.events.search.set_search_events();
    },
  },
  behavioral: {
    variables: {},
    _setViewedProduct: (handle) => {
      if (handle) {
        return window.SimpleCore._session.update("last_seen_products", handle);
      }
    },
    init: async () => {
      await theme.events.behavioral.get_product_data();
    },
    get_product_data: async (index = 0) => {
      if (isPage("template-product")) {
        const $product_details = JSON.parse(
          document.querySelector("[data-product-json]").innerHTML
        );

        theme.events.behavioral._setViewedProduct(
          $product_details.product.handle
        );
      }
    },
    set_events: async () => {
      theme.events.search.set_search_events();
    },
  },
};

theme.event_tracker.init();
theme.event_tracker.event();
theme.events.behavioral.init();

theme.events.popup.init();
theme.events.search.init();
theme.events.minicart.init();
theme.events.product_item.init();

if (isPage("template-index")) {
  theme.events.homepage.init();
}
if (isPage("template-product")) {
  theme.events.product_page.init();
}
